import React from 'react';
import UserProfileProvider from '../../services/manager/UserProfileProvider';

const UserProfile = React.lazy(() => import('./UserProfile'));
export const profileConfig = [
  {
    path: '/my-profile',
    showRouteForVerified: false,
    element: (
      <UserProfileProvider>
        <UserProfile />
      </UserProfileProvider>
    ),
  },
];
